import React from "react";

import type { AnnotationMarkerReadModel } from "./annotationMarker.types";

export default function AnnotationMarkerGlyph({ marker }: { marker: AnnotationMarkerReadModel }): JSX.Element {
  const borderColor = marker.isSelected ? "rgba(255,255,255,0.96)" : marker.palette.border;
  const glowColor = marker.isFresh ? marker.palette.glow : "rgba(255,255,255,0.16)";

  return (
    <>
      <span
        aria-hidden
        className="absolute inset-[1px] rounded-[4px] -rotate-45"
        style={{
          border: `1px solid ${borderColor}`,
          background: marker.palette.fill,
          boxShadow: marker.isSelected
            ? `0 0 18px ${marker.palette.glow}, 0 0 0 1px rgba(255,255,255,0.15)`
            : `0 0 12px ${glowColor}`,
          opacity: marker.visualState === "published" ? 1 : 0.92,
        }}
      />
      <span
        aria-hidden
        className="absolute inset-[4px] rounded-[2px] -rotate-45"
        style={{
          background: marker.visualState === "published" ? "rgba(255,255,255,0.92)" : marker.palette.border,
          boxShadow: marker.isFresh ? `0 0 10px ${marker.palette.glow}` : "none",
        }}
      />
    </>
  );
}